import {
  CapaQuotationRfqDetail,
  CapaQuotationServiceType,
  CapaQuotationUserRfqDetail
} from '@generated/graphql';
import { CapaFile, EnumFileCategory, FileCategory } from './types';

export const imageExtensions = ['jpg', 'jpeg', 'png'];

export const drawingFileExtensions = 'zip, .rar, .dwg, .dxf, .stp, .step, .OBJ, .SKP, .STL, .SAT, .SAB, .IPT, .MODEL, .SESSION, .DLV, .EXP, .CATPart, .CGR, .DAE, .NEU, .PRT, .XPR, .FBX, .GLTF, .GLB, .IFC, .IGS, .IGES, .JT, .X_B, .X_T, .RVT, .3DM, .PAR, .PSM, .SLDPRT, .STP, .STEP'
  .toLowerCase()
  .split(', .');

export const verifiableExtensions = imageExtensions
  .concat(drawingFileExtensions)
  .concat(['pdf']);

export const getExtension = (fileName: string) => {
  return fileName?.slice(fileName.lastIndexOf('.') + 1).toLowerCase();
};

export const getFileType = (extension: string): FileCategory => {
  if (!extension) return EnumFileCategory.ERROR;

  if (drawingFileExtensions.includes(extension))
    return EnumFileCategory.DRAWING_FILE;

  if (imageExtensions.includes(extension)) return EnumFileCategory.IMAGE;

  if ('pdf' === extension) return EnumFileCategory.PDF;

  return EnumFileCategory.ERROR;
};

export const getRfqFiles = (
  data?: CapaQuotationUserRfqDetail | CapaQuotationRfqDetail
): CapaFile[] => {
  if (!data) return [];

  const isPcb = data?.serviceType === CapaQuotationServiceType.Pcb;

  const rfqPcbFiles: CapaFile[] =
    data?.pcb?.fabricationFiles && data?.pcb.fabricationFiles.length > 0
      ? data?.pcb.fabricationFiles.map((file) => ({
          fileId: file.fileId ?? undefined,
          fileName: file.fileName ?? undefined,
          fileSize: 0
        }))
      : [];

  const rfqAssemblyFiles =
    data?.pcb?.assemblyFiles && data?.pcb.assemblyFiles.length > 0
      ? data?.pcb.assemblyFiles.map((file) => ({
          fileId: file.fileId ?? undefined,
          fileName: file.fileName ?? undefined,
          fileSize: 0
        }))
      : [];

  const rfqDrawingFiles: CapaFile[] =
    data?.drawingFiles && data?.drawingFiles.length > 0
      ? data?.drawingFiles.map((file) => ({
          fileId: file.fileId ?? undefined,
          fileName: file.fileName ?? undefined,
          fileSize: 0
        }))
      : [];

  const rfqReferenceFiles: CapaFile[] =
    data?.referenceFiles && data?.referenceFiles.length > 0
      ? data?.referenceFiles.map((file) => ({
          fileId: file.fileId ?? undefined,
          fileName: file.fileName ?? undefined,
          fileSize: 0
        }))
      : [];

  return [
    ...(isPcb ? [...rfqPcbFiles, ...rfqAssemblyFiles] : rfqDrawingFiles),
    ...rfqReferenceFiles
  ];
};
